/**
 * FIXME: remove this when we aren't writing to `/dist/` directly
 * Quick fix to support lazy loading from `/dist/`
 * Note: This must run before anything else that might lazy-load
 */
declare let __webpack_public_path__: string;
__webpack_public_path__ = 'dist/';
